module.exports = __webpack_public_path__ + "static/media/user.a656db54.svg";